import React, { useState, useEffect } from 'react';
import { Grid, FormGroup, ControlLabel, Button, Row, Col } from 'react-bootstrap';
import Request from 'superagent';
import DatePicker, { registerLocale } from 'react-datepicker';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import keyGen from 'random-key';
import moment from 'moment';
import { RingLoader } from 'react-spinners';
import enGB from 'date-fns/locale/en-GB';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('en-GB', enGB);

export default function Tokens({ userProfile, eventID }) {
    const [tokenExpiryDate, setTokenExpiryDate] = useState(new Date());
    const [tokenMinDate] = useState(new Date());
    const [selectedRows, setSelectedRows] = useState([]);
    const [screens, setScreens] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getAllScreens(eventID);
    }, [eventID]);

    function getAllScreens(id) {
        if (id === 0) {
            setScreens([]);
        } else {
            setLoading(true);
            const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=queryGetEventScreens&argument2=' + JSON.stringify({ eventID: id });
            Request.get(url).then((response) => {
                if (response.body[0].Result === 'OK') {
                    setScreens(response.body[0].data);
                } else {
                    alert('Error in getAllScreens: ' + response.body[0].data);
                }
                setLoading(false);
            });
        }
    }

    function updateScreens(updatedScreens) {
        const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=updateEventScreens';
        Request.post(url)
            .send(JSON.stringify(updatedScreens))
            .then((response) => {
                if (response.body[0].Result !== 'OK') {
                    getAllScreens(eventID);
                    alert('An error occurred generating tokens. Please try again. If the problem persists, contact support.');
                } else {
                    setSelectedRows([]);
                }
            });
    }

    function generateToken() {
        const newScreens = screens.map(row => {
            if (selectedRows.findIndex(x => x === row.event_screen_id) > -1) {
                const token = keyGen.generateBase30(6);
                return { ...row, token_expiry_date: moment(tokenExpiryDate).format('DD/MM/YYYY'), screen_token: token.substr(0, 3) + '-' + token.substr(3, 5) };
            }
            return row;
        });
        setScreens(newScreens);
        updateScreens(newScreens);
    }

    function onRowSelect(row, isSelected) {
        setSelectedRows(prev =>
            isSelected ? [...prev, row.event_screen_id] : prev.filter(id => id !== row.event_screen_id)
        );
    }

    function onSelectAll(isSelected, rows) {
        setSelectedRows(isSelected ? rows.map(r => r.event_screen_id) : []);
    }

    function copyUrl(token) {
        navigator.clipboard.writeText(window.location.origin + '/' + token);
    }

    function copyAll() {
        const text = screens
            .filter(row => row.screen_token)
            .map(row => row.screen_name + ' - ' + window.location.origin + '/' + row.screen_token)
            .join('\n');
        navigator.clipboard.writeText(text);
    }

    function copyUrlFormatter(cell) {
        if (!cell) return '';
        return (
            <button style={{ cursor: 'pointer', fontSize: '11px', padding: '1px 6px' }}
                onClick={(e) => { e.stopPropagation(); copyUrl(cell); }}>
                Copy URL
            </button>
        );
    }

    const rowStyle = { display: eventID === 0 ? 'none' : 'block' };
    const selectRowProp = {
        mode: 'checkbox',
        onSelect: onRowSelect,
        onSelectAll,
        selected: selectedRows,
    };
    const options = { defaultSortName: 'screen_name', defaultSortOrder: 'asc' };

    return (
        <div>
            <div style={{ height: 0, width: 0, left: '40%', top: '35%', zIndex: 1, position: 'absolute' }}>
                <RingLoader color={'#d41e3d'} loading={loading} size={200} />
            </div>
            <Grid fluid={true}>
                <Row style={rowStyle}>
                    <Col xs={6}>
                        <BootstrapTable data={screens} options={options} striped hover height='280px' selectRow={selectRowProp}>
                            <TableHeaderColumn hidden isKey={true} dataField='event_screen_id'>ID</TableHeaderColumn>
                            <TableHeaderColumn className='screenName' dataField='screen_name'>Dashboard</TableHeaderColumn>
                            <TableHeaderColumn className='screenToken' dataField='screen_token'>Token</TableHeaderColumn>
                            <TableHeaderColumn dataField='screen_token' dataFormat={copyUrlFormatter} width='100'>Link</TableHeaderColumn>
                            <TableHeaderColumn className='tokenExpiryDate' dataField='token_expiry_date'>Expiry Date</TableHeaderColumn>
                        </BootstrapTable>
                    </Col>
                    <Col xs={6}>
                        <FormGroup controlId="TOKENEXPIRY">
                            <ControlLabel>Generate new tokens for selected dashboards</ControlLabel>
                            <br />
                            Expiry Date{' '}
                            <DatePicker selected={tokenExpiryDate} name="datePicker"
                                minDate={tokenMinDate} showClearButton={false} locale='en-GB'
                                placeholderText="Select date tokens expire"
                                onChange={setTokenExpiryDate} dateFormat="dd/MMM/YYYY" />
                            <br /><br />
                            <Button key="generate" name="generate" bsStyle="primary"
                                onClick={generateToken}
                                disabled={selectedRows.length === 0}>
                                Generate
                            </Button>
                            {' '}
                            <Button key="copyAll" name="copyAll" bsStyle="default"
                                onClick={copyAll}
                                disabled={screens.filter(r => r.screen_token).length === 0}>
                                Copy All URLs
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
            </Grid>
        </div>
    );
}
